import * as React from 'react';
import styled from '@emotion/styled';
import { Button  } from '@mui/material';

const ButtonStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  background: theme.palette.primary.main,
  borderRadius: `${theme.theme_component_feature_grid_a_card_button_border_radius}px`,
  fontSize: theme.theme_component_feature_grid_a_card_button_font_size || '16px',
  fontWeight: theme.theme_component_feature_grid_a_card_button_font_weight,
  padding: "6px 16px",
}));

export const CustomButton = ({ children, ...rest}: any) => {
  return (
    <ButtonStyled {...rest}>
      {children}
    </ButtonStyled>
  );
}